import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CustomCard } from '../../../types/custom-card';
import { UniversalState } from '../../../types/state';
import API from '../../../util/api';

export const fetchCustomCardThunk = createAsyncThunk('customcard/fetchCustomCard', async () => {
  const result = await API.get('customcard');
  return result.data as CustomCard[];
});

export const createCustomCard = createAsyncThunk('customcard/createCustomCard', async (data, { dispatch }) => {
  await API.post('customcard', data);
  await dispatch(fetchCustomCardThunk());
});

export const deleteCustomCard = createAsyncThunk('customcard/deleteCustomCard', async (data, { dispatch }) => {
  await API.delete(`customcard/${data}`);
  await dispatch(fetchCustomCardThunk());
});

const initialState: UniversalState<CustomCard[]> = {
  data: [],
  loading: false,
  error: null,
};

const cardSlice = createSlice({
  name: 'custom',
  initialState,
  reducers: {
    clearCustomCardSubmitting(state) {
      state.isSubmitting = undefined;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomCardThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCustomCardThunk.fulfilled, (state, action) => {
      state.data = action.payload as any;
      state.loading = false;
    });
    builder.addCase(fetchCustomCardThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action;
    });
    builder.addCase(createCustomCard.pending, (state) => {
      state.isSubmitting = true;
      state.error = null;
    });
    builder.addCase(createCustomCard.fulfilled, (state) => {
      state.isSubmitting = false;
      state.error = null;
    });
    builder.addCase(createCustomCard.rejected, (state, action) => {
      state.isSubmitting = false;
      state.error = action;
    });
    builder.addCase(deleteCustomCard.pending, (state) => {
      state.isSubmitting = true;
      state.error = null;
    });
    builder.addCase(deleteCustomCard.fulfilled, (state) => {
      state.isSubmitting = false;
      state.error = null;
    });
    builder.addCase(deleteCustomCard.rejected, (state, action) => {
      state.isSubmitting = false;
      state.error = action;
    });
  },
});

const { reducer, actions } = cardSlice;

export const { clearCustomCardSubmitting } = actions;

export default reducer;
